import styled from 'styled-components';
import { getStyledCounterStyles } from './style';
import { StyledCounterProps } from './type';

const StyledCounter = styled.div<StyledCounterProps>(({ theme, backgroundColor }) =>
	getStyledCounterStyles({ theme, backgroundColor })
);

export default StyledCounter;
